import {
  ActionIcon,
  Anchor,
  Avatar,
  Box,
  Card,
  Center,
  Divider,
  Group,
  Modal,
  ScrollArea,
  Skeleton,
  Table,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { useEffect, useRef, useState } from "react";
import { IconArrowUpRight, IconCamera } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { logger } from "utils/logger";
import { EmptyState } from "core/components/emptyState/EmptyState";
import { createStyles } from "@mantine/emotion";
import { getStyle } from "services/styleService";
import { useDispatch } from "react-redux";
import { selectStyle, setError } from "modules/Distributions/distributionSlice";
import ResolverImage from "core/components/resolverImage/ResolverImage";
import Moment from "react-moment";

import ImagePreview from "core/components/imagePreview/ImagePreview";
// import StyleAssetViewer from "../style/StyleAssetViewer";
import { AppConstants, ERROR_MESSAGES, ERROR_TYPES } from "utils/constants";
import { PrimaryBadge } from "core/components/badge/PrimaryBadge";
import { MetaLabel } from "core/components/metaLabel/MetaLabel";
import StyleInfoSections from "core/components/styleInfoSections/StyleInfoSections";
import StyleAssetViewer from "core/components/styleInfoPanel/StyleAssetViewer";
import { getClientLabel } from "utils/helper";
import { DateDisplay } from "core/components/index";

const useStyles = createStyles((theme, _, u) => ({
  container: {
    padding: 0,
    height: "100%",
    borderLeftWidth: 0,
    borderLeftStyle: "solid",
    // paddingTop: 26,
    borderColor: theme.colors.dark[4],
    [u.light]: {
      borderColor: theme.colors.gray[3],
    },
    ".mantine-Accordion-content": {
      paddingBottom: 0,
    },
    ".mantine-Accordion-control": {
      borderTopWidth: 1,
      borderTopStyle: "solid",
      borderColor: theme.colors.dark[4],
      [u.light]: {
        borderColor: theme.colors.gray[3],
      },
    },
    ".mantine-Stack-root": {
      // gap: 0,
    },
    ".capture-selected > div > div:first-of-type": {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.colors.brand[1],
      [u.light]: {
        borderColor: theme.colors.gray[3],
      },
    },
  },
  badgeIndex: {
    position: "absolute",
    left: 0,
    top: 0,
  },
  imageGradient: {
    background: `linear-gradient(to top, #242424, transparent)`,
    height: 200,
    width: "100%",
    position: "absolute",
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 16,
    [u.light]: {
      background: `linear-gradient(to top, #fff, transparent)`,
    },
  },
}));

const InfoPanel = ({ selectedItem, opened, user }) => {
  const { classes } = useStyles();
  const [activeTab, setActiveTab] = useState("info");
  const [session, setSelectedSession] = useState(null);
  const [talent, setTalent] = useState([]);
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  const [selectedAsset, setSelectedAsset] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const lastFetchedStyleNumber = useRef(null);

  useEffect(() => {
    logger.log(selectedItem);

    const getStyleInfo = async (id) => {
      setLoading(true);
      try {
        const data = await getStyle(id);

        if (data) {
          logger.log(data);
          const { masters, sessions, seasons, assets, ...rest } = data;
          dispatch(
            selectStyle({ ...data, masters, sessions, seasons, assets })
          );
        }
      } catch (e) {
        dispatch(
          setError({
            type: ERROR_TYPES.NOT_FOUND,
            message: ERROR_MESSAGES[ERROR_TYPES.NOT_FOUND],
          })
        );
      } finally {
        setLoading(false);
      }
    };
    if (selectedItem && selectedItem.styleNumber) {
      const styleNumber = selectedItem.styleNumber;
      const isDifferentStyle = lastFetchedStyleNumber.current !== styleNumber;

      // Reset fetch flag if it's a different style
      if (isDifferentStyle) {
        hasFetched.current = false;
      }

      if (
        (!selectedItem.assets || selectedItem.assets.length === 0) &&
        !hasFetched.current &&
        opened
      ) {
        getStyleInfo(selectedItem.styleNumber);
        hasFetched.current = true;
        lastFetchedStyleNumber.current = styleNumber;
      } else if (!opened) {
        hasFetched.current = false;
        lastFetchedStyleNumber.current = null;
      }
    } else if (!selectedItem) {
      // Reset when selectedItem is null
      hasFetched.current = false;
      lastFetchedStyleNumber.current = null;
    }
  }, [selectedItem, opened, dispatch]);

  const zoomImage = (data) => {
    logger.log(data);
    setSelectedAsset(data);
    setImageModalOpen(true);
  };

  return (
    <Box className={`${classes.container} info-panel unhightable`}>
      <div style={{ width: "100%", height: "calc(100% - 46px)" }}>
        <ScrollArea sx={{ height: "100%" }}>
          {selectedItem ? (
            <Card pt="lg" style={{ background: "none" }}>
              <Card.Section style={{ position: "relative" }}>
                {/* <Image src={src} alt={''} height={size} /> */}
                <ResolverImage
                  className={classes.image}
                  fit="cover"
                  src={
                    selectedItem &&
                    selectedItem.assets &&
                    selectedItem.assets.length
                      ? selectedItem?.assets[0].preview
                      : ""
                  }
                  alt={selectedItem?.name}
                  height={300}
                />
                {/* {selectedItem &&
                selectedItem.assets &&
                selectedItem.assets.length ? (
                  <AnimatePresence mode="wait">
                    <motion.img
                      key={currentIndex}
                      src={selectedItem?.assets[currentIndex].preview}
                      alt={`Slide ${currentIndex}`}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 1 }}
                      transition={{ duration: 5 }}
                      style={{
                        width: "100%",
                        height: 300,
                        objectFit: "cover",
                        position: "relative",
                      }}
                    />
                  </AnimatePresence>
                ) : null} */}

                <div className={classes.imageGradient}></div>
              </Card.Section>
              <Link
                className="router-link unstyled"
                to={`/distributions/${selectedItem.styleNumber}`}
              >
                <Group wrap={false} justify="space-between" mt="lg">
                  <Title
                    className="main-content-heading"
                    order={5}
                    w={300}
                    display={"inline-block"}
                    textWrap={true}
                  >
                    {selectedItem?.name}
                  </Title>
                  <Tooltip color="dark" label="Navigate to Style">
                    <ActionIcon variant="default">
                      <IconArrowUpRight
                        size={AppConstants.ICON_SIZE}
                        stroke={AppConstants.ICON_STROKE_WIDTH}
                      />
                    </ActionIcon>
                  </Tooltip>
                </Group>
              </Link>
              <Box>
                <Group my="md">
                  <MetaLabel>Style Number</MetaLabel>
                  <div>
                    <Text size="sm">
                      <Anchor
                        component={Link}
                        to={`/distributions/${selectedItem.styleNumber}`}
                      >
                        {selectedItem?.styleNumber}
                      </Anchor>
                    </Text>
                  </div>
                </Group>
                <Group my="md">
                  <MetaLabel>Department</MetaLabel>
                  <div>
                    <Text size="sm">{selectedItem.dept}</Text>
                  </div>
                </Group>

                <Group my="md">
                  <MetaLabel>{getClientLabel(user.clientCode, 'otbDate')}</MetaLabel>
                  <div>
                    <Text
                      size="sm"
                      c={
                        selectedItem.otbDate && selectedItem.otbDate.length
                          ? "inherit"
                          : "dimmed"
                      }
                    >
                      {selectedItem.otbDate && selectedItem.otbDate.length ? (
                        <DateDisplay
                          value={selectedItem.otbDate}
                          parse="YYYY-MM-DD-hh-mm-ss"
                          format="DD/MM/YYYY"
                          trim
                        />
                      ) : (
                        "-"
                      )}
                    </Text>
                  </div>
                </Group>

                <Group my="md">
                  <MetaLabel>Shoot Date</MetaLabel>
                  <div>
                    <Text
                      size="sm"
                      c={
                        selectedItem.shootDate && selectedItem.shootDate.length
                          ? "inherit"
                          : "dimmed"
                      }
                    >
                      {selectedItem.shootDate && selectedItem.shootDate.length
                        ? selectedItem.shootDate
                        : "-"}
                    </Text>
                  </div>
                </Group>

                <Group my="md">
                  <MetaLabel>Distribution Date</MetaLabel>
                  <div>
                    <Text
                      size="sm"
                      c={
                        selectedItem.distributionDate &&
                        selectedItem.distributionDate.length
                          ? "inherit"
                          : "dimmed"
                      }
                    >
                      {selectedItem.distributionDate &&
                      selectedItem.distributionDate.length ? (
                        <Moment
                          date={selectedItem.distributionDate}
                          parse="YYYY-MM-DD-hh-mm-ss"
                          format="DD/MM/YYYY"
                          trim
                        />
                      ) : (
                        "-"
                      )}
                    </Text>
                  </div>
                </Group>
              </Box>
              {/* <Divider /> */}

              <StyleInfoSections
                selectedItem={selectedItem}
                user={user}
                loading={loading}
                storageKey={'op-dist-drawer'}
              />
              <Divider />
              <Box mt={"md"}>
                <Group mb="lg">
                  <Title className="main-content-heading" order={6}>
                    Assets
                  </Title>
                  {selectedItem?.assets?.length ? (
                    <PrimaryBadge>{selectedItem?.assets?.length}</PrimaryBadge>
                  ) : null}
                </Group>
                <Group
                  gap={"md"}
                  wrap="wrap"
                  justify="start"
                  style={{ display: "flex" }}
                >
                  {loading ? (
                      // Show skeletons when loading
                      [...Array(3)].map((_, idx) => (
                        <Skeleton key={`skeleton-${idx}`} height={100} width={80} radius={8} />
                      ))
                    ) : (
                      // Show actual assets when not loading
                      selectedItem?.assets?.map((val, idx) => {
                        // var imageURL = val && val.preview ? val.preview : "";
                        return (
                          <div
                            key={idx}
                            style={{
                              height: "100%",
                              width: 80,
                              position: "relative",
                              borderRadius: 8,
                              overflow: "hidden",
                            }}
                          >
                            {val ? (
                              <ImagePreview
                                file={{ url: val?.thumb }}
                                onClick={() => zoomImage(val)}
                                height={100}
                                width={"auto"}
                              />
                            ) : (
                              //   <ImagePreview
                              //     shot={{ ...val, ...selectedItem }}
                              //     size={100}
                              //     src={imageURL}
                              //     tags={val.tags}
                              //     fit="contain"
                              //     showMetaInfo={false}
                              //   />
                              <div></div>
                            )}
                          </div>
                        );
                      })
                    )}
                </Group>

                {!selectedItem ||
                (selectedItem && selectedItem.assets?.length === 0) ? (
                  <EmptyState
                    caption="There are no assets"
                    style={{ height: 200 }}
                  />
                ) : null}
                {/* <TalentList data={[{avatar:selectedItem.filePath,name:'Test User'}]}/> */}
              </Box>
            </Card>
          ) : (
            <Center style={{ height: "100%", minHeight: 400 }}>
              <div style={{ textAlign: "center" }}>
                {/* <IconCamera size={48} stroke={1} /> */}
                <Title color={"dimmed"} order={3}>
                  Select a record
                </Title>
              </div>
            </Center>
          )}
        </ScrollArea>
      </div>

      <Modal
        opened={imageModalOpen}
        p={0}
        // title={selectedItem.name}
        trapFocus={true}
        closeOnEscape={true}
        id="captureModal"
        withCloseButton={false}
        fullScreen
        onClose={() => setImageModalOpen(false)}
        styles={{
          content: { padding: 0, height: "100vh" },
        }}
      >
        {/* <CaptureDetail
          showSettings={false}
          resoloveImage={false}
          image={selectedAsset}
          src={selectedAsset?.preview}
          onImageEvent={() => logger.log("On image event")}
          onCaptureChange={() => {}}
        /> */}

        <StyleAssetViewer
          user={user}
          style={selectedItem}
          index={selectedItem?.assets?.findIndex(
            (val) => val.assignedSequence === selectedAsset?.assignedSequence
          )}
          onClose={() => setImageModalOpen(false)}
        />
      </Modal>
    </Box>
  );
};

export default InfoPanel;

export function TalentList({ data }) {
  const rows = data.map((item) => (
    <tr key={item.name}>
      <td>
        <Group spacing="sm">
          <Avatar size={40} src={item.avatar} radius={40} />
          <div>
            <Text size="sm" weight={500}>
              {item.name}
            </Text>
            <Text size="xs" color="dimmed">
              {item.email}
            </Text>
          </div>
        </Group>
      </td>

      {/* <td>
        
      </td>
      <td>{Math.floor(Math.random() * 6 + 5)} days ago</td>
      <td>
        {Math.random() > 0.5 ? (
          <Badge fullWidth>Active</Badge>
        ) : (
          <Badge color="gray" fullWidth>
            Disabled
          </Badge>
        )}
      </td> */}
    </tr>
  ));

  return (
    <Table verticalSpacing="sm">
      {/* <thead>
          <tr>
            <th>Employee</th>
            <th>Role</th>
            <th>Last active</th>
            <th>Status</th>
          </tr>
        </thead> */}
      <tbody>{rows}</tbody>
    </Table>
  );
}
